// import React, { useEffect, useState } from "react";
// import { Link, useParams } from "react-router-dom";
// import Navbar from "../navbar/Navbar";
// import Footer from "../Footer/Footer";
// import { Icon } from "@iconify/react";

// // Define items per page - should match the limit in your API call
// const ITEMS_PER_PAGE = 10;

// export default function Product() {
// 	const { year, category } = useParams();
// 	const [data, setData] = useState([]);
// 	const [loading, setLoading] = useState(true);
// 	const [error, setError] = useState(null);
// 	const [currentPage, setCurrentPage] = useState(1);
// 	const [pagination, setPagination] = useState({
// 		total: 0,
// 		totalPages: 0,
// 		hasNextPage: false,
// 		hasPrevPage: false,
// 	});

// 	const PRIMARY_COLOR = "#072349";
// 	const HOVER_COLOR = "#072349 / 0.8";

// 	// --- Updated Data Fetching Logic with Server-Side Pagination ---
// 	useEffect(() => {
// 		const fetchData = async () => {
// 			try {
// 				setLoading(true);

// 				// Build query parameters with pagination
// 				const params = new URLSearchParams({
// 					year: year,
// 					category:
// 						category === "Prom"
// 							? `Prom`
// 							: category === "Enchanted Bridal"
// 							? `Enchanted Bridal`
// 							: category === "Enchanted Evening"
// 							? `Enchanted Evening`
// 							: category,
// 					page: currentPage.toString(),
// 					brand: "Monsini",
// 					limit: ITEMS_PER_PAGE.toString(),
// 				});

// 				console.log("parms : ", params.toString());
// 				const response = await fetch(
// 					`http://localhost:3200/api/products?${params}`
// 				);

// 				if (!response.ok) throw new Error("Failed to fetch data");

// 				const result = await response.json();

// 				// Check if the API response has the expected structure
// 				if (result.success && result.data) {
// 					setData(result.data.products || []);
// 					setPagination(
// 						result.data.pagination || {
// 							total: 0,
// 							totalPages: 0,
// 							hasNextPage: false,
// 							hasPrevPage: false,
// 						}
// 					);
// 					console.log("Fetched data:", result.data);
// 				} else {
// 					throw new Error("Invalid data structure from API");
// 				}
// 			} catch (err) {
// 				setError(err.message);
// 				setData([]);
// 				setPagination({
// 					total: 0,
// 					totalPages: 0,
// 					hasNextPage: false,
// 					hasPrevPage: false,
// 				});
// 			} finally {
// 				setLoading(false);
// 			}
// 		};
// 		fetchData();
// 	}, [year, category, currentPage]); // Add currentPage to dependencies

// 	const handlePageChange = (page) => {
// 		if (page > 0 && page <= pagination.totalPages) {
// 			setCurrentPage(page);
// 			window.scrollTo({ top: 0, behavior: "smooth" });
// 		}
// 	};

// 	if (loading)
// 		return (
// 			<div className="flex flex-col justify-center items-center min-h-screen bg-gray-50">
// 				{/* Spinning Icon */}
// 				<Icon
// 					icon="svg-spinners:ring-resize"
// 					className="w-16 h-16 text-pink-600 animate-spin-slow"
// 				/>

// 				{/* Loading Text */}
// 				<div className="text-xl font-semibold text-gray-700 mt-4 font-poppins">
// 					Loading Monsini Collection...
// 				</div>

// 				{/* Optional: Simple Subtext for a better user experience */}
// 				<p className="text-sm text-gray-500 mt-1">
// 					Fetching the latest styles.
// 				</p>
// 			</div>
// 		);

// 	if (error)
// 		return <div className="text-center mt-20 text-red-500">Error: {error}</div>;

// 	return (
// 		<div className="">
// 			<Navbar />
// 			<h1
// 				className={`mt-[90px] text-5xl font-extrabold font-americana text-center mb-16 text-white py-20 tracking-tight
//     ${
// 			category === "prom"
// 				? "bg-pink-300"
// 				: category === "bridal"
// 				? "bg-pink-500"
// 				: category === "evening"
// 				? "bg-[#072349]"
// 				: "bg-[#072349]"
// 		}
//   `}>
// 				{category === "prom"
// 					? `Monsini Prom ${year}`
// 					: category === "bridal"
// 					? `Enchanted Bridal ${year}`
// 					: category === "evening"
// 					? `Enchanted Evening ${year}`
// 					: ""}{" "}
// 				Collection
// 			</h1>

// 			{data && data.length > 0 ? (
// 				<>
// 					<div className="py-5 px-6 sm:px-10 lg:px-20 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
// 						{data.map((item, index) => (
// 							<Link
// 								to={`/product/id/${item.style}`}
// 								state={{
// 									product: item,
// 								}}
// 								key={item._id || index}
// 								className="bg-white shadow-lg overflow-hidden group border-b-4 border-transparent hover:border-b-4 transition-all duration-300 transform hover:shadow-xl"
// 								style={{ borderBottomColor: PRIMARY_COLOR }}>
// 								<div className="relative overflow-hidden">
// 									<img
// 										src={`https://admin.monsinidress.com/${item.images[0]}`}
// 										alt={item.style}
// 										className="w-full lg:h-[450px] md:h-[300px] sm:h-[450px] h-[450px] object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
// 									/>
// 									<div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent flex items-end opacity-0 group-hover:opacity-100 transition-opacity duration-300">
// 										<div className="p-4 w-full text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out">
// 											<div className="flex justify-between items-center mb-2">
// 												<h2 className="font-bold text-xl drop-shadow-md">
// 													{item.style}
// 												</h2>
// 												<div className="flex justify-between items-center text-sm">
// 													<button
// 														className="px-4 py-1.5 rounded-full text-sm font-semibold transition-colors"
// 														style={{
// 															backgroundColor: PRIMARY_COLOR,
// 															color: "white",
// 														}}
// 														onMouseOver={(e) =>
// 															(e.currentTarget.style.backgroundColor =
// 																HOVER_COLOR)
// 														}
// 														onMouseOut={(e) =>
// 															(e.currentTarget.style.backgroundColor =
// 																PRIMARY_COLOR)
// 														}>
// 														View Dress
// 													</button>
// 												</div>
// 											</div>
// 										</div>
// 									</div>
// 								</div>
// 							</Link>
// 						))}
// 					</div>

// 					{/* Pagination Controls using backend pagination data */}
// 					{pagination.totalPages > 1 && (
// 						<div className="flex justify-center items-center my-10 space-x-2 md:flex-row sm:flex-col flex-col gap-4">
// 							<button
// 								onClick={() => handlePageChange(currentPage - 1)}
// 								disabled={!pagination.hasPrevPage}
// 								className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-300 ${
// 									!pagination.hasPrevPage
// 										? "bg-gray-200 text-gray-500 cursor-not-allowed"
// 										: "text-white"
// 								}`}
// 								style={{
// 									backgroundColor: pagination.hasPrevPage
// 										? PRIMARY_COLOR
// 										: undefined,
// 								}}
// 								onMouseOver={(e) =>
// 									pagination.hasPrevPage &&
// 									(e.currentTarget.style.backgroundColor = HOVER_COLOR)
// 								}
// 								onMouseOut={(e) =>
// 									pagination.hasPrevPage &&
// 									(e.currentTarget.style.backgroundColor = PRIMARY_COLOR)
// 								}>
// 								Previous
// 							</button>

// 							<div className="flex gap-2">
// 								{[...Array(pagination.totalPages).keys()].map((page) => {
// 									const pageNum = page + 1;
// 									if (
// 										pageNum === 1 ||
// 										pageNum === pagination.totalPages ||
// 										(pageNum >= currentPage - 1 && pageNum <= currentPage + 1)
// 									) {
// 										return (
// 											<button
// 												key={pageNum}
// 												onClick={() => handlePageChange(pageNum)}
// 												className={`w-10 h-10 rounded-full font-semibold transition-colors duration-300 ${
// 													pageNum === currentPage
// 														? "bg-pink-300 text-white shadow-md"
// 														: "bg-gray-100 text-gray-700 hover:bg-gray-200"
// 												}`}
// 												style={
// 													pageNum === currentPage
// 														? { backgroundColor: PRIMARY_COLOR, color: "white" }
// 														: {}
// 												}>
// 												{pageNum}
// 											</button>
// 										);
// 									}
// 									if (pageNum === 2 && currentPage > 2) {
// 										return (
// 											<span key="start-ellipsis" className="text-gray-500">
// 												...
// 											</span>
// 										);
// 									}
// 									if (
// 										pageNum === pagination.totalPages - 1 &&
// 										currentPage < pagination.totalPages - 1
// 									) {
// 										return (
// 											<span key="end-ellipsis" className="text-gray-500">
// 												...
// 											</span>
// 										);
// 									}
// 									return null;
// 								})}
// 							</div>

// 							<button
// 								onClick={() => handlePageChange(currentPage + 1)}
// 								disabled={!pagination.hasNextPage}
// 								className={`px-4 py-2 rounded-full md:text-sm font-semibold transition-colors duration-300 ${
// 									!pagination.hasNextPage
// 										? "bg-gray-200 text-gray-500 cursor-not-allowed"
// 										: "text-white"
// 								}`}
// 								style={{
// 									backgroundColor: pagination.hasNextPage
// 										? PRIMARY_COLOR
// 										: undefined,
// 								}}
// 								onMouseOver={(e) =>
// 									pagination.hasNextPage &&
// 									(e.currentTarget.style.backgroundColor = HOVER_COLOR)
// 								}
// 								onMouseOut={(e) =>
// 									pagination.hasNextPage &&
// 									(e.currentTarget.style.backgroundColor = PRIMARY_COLOR)
// 								}>
// 								Next
// 							</button>
// 						</div>
// 					)}
// 				</>
// 			) : (
// 				<div className="text-center text-gray-600 mt-20 p-10 bg-gray-50 rounded-xl">
// 					<p className="text-xl font-semibold mb-8">
// 						No data available for {year}.
// 					</p>
// 					<a
// 						href="/"
// 						className="inline-block px-8 py-3 rounded-full text-lg font-semibold transition-colors duration-300 shadow-lg"
// 						style={{ backgroundColor: PRIMARY_COLOR, color: "white" }}
// 						onMouseOver={(e) =>
// 							(e.currentTarget.style.backgroundColor = HOVER_COLOR)
// 						}
// 						onMouseOut={(e) =>
// 							(e.currentTarget.style.backgroundColor = PRIMARY_COLOR)
// 						}>
// 						Back to Collections
// 					</a>
// 				</div>
// 			)}
// 			<Footer />
// 		</div>
// 	);
// }

import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Navbar from "../navbar/Navbar";
import Footer from "../Footer/Footer";
import { Icon } from "@iconify/react";

// Define items per page - should match the limit in your API call
const ITEMS_PER_PAGE = 12;

export default function Product() {
	const { year, category } = useParams();
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [currentPage, setCurrentPage] = useState(1);
	const [pagination, setPagination] = useState({
		total: 0,
		totalPages: 0,
		hasNextPage: false,
		hasPrevPage: false,
	});

	const PRIMARY_COLOR = "#072349";
	const HOVER_COLOR = "#072349 / 0.8";

	// Function to map URL category to backend category
	const getBackendCategory = (urlCategory) => {
		const categoryMap = {
			prom: "Prom",
			bridal: "Enchanted Bridal",
			evening: "Enchanted Evening",
		};
		return categoryMap[urlCategory] || urlCategory;
	};

	// --- Updated Data Fetching Logic with Server-Side Pagination ---
	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoading(true);

				// Build query parameters with pagination
				const backendCategory = getBackendCategory(category);

				const params = new URLSearchParams({
					year: year,
					category: backendCategory,
					page: currentPage.toString(),
					brand: "Monsini",
					limit: ITEMS_PER_PAGE.toString(),
				});

				console.log("API Parameters:", {
					year: year,
					category: backendCategory,
					brand: "Monsini",
					page: currentPage,
				});

				const response = await fetch(
					`https://admin.monsinidress.com/api/products?${params}`
				);

				if (!response.ok) throw new Error("Failed to fetch data");

				const result = await response.json();

				// Check if the API response has the expected structure
				if (result.success && result.data) {
					setData(result.data.products || []);
					setPagination(
						result.data.pagination || {
							total: 0,
							totalPages: 0,
							hasNextPage: false,
							hasPrevPage: false,
						}
					);
					console.log("Fetched data count:", result.data.products?.length || 0);
					console.log("Pagination info:", result.data.pagination);
				} else {
					throw new Error("Invalid data structure from API");
				}
			} catch (err) {
				console.error("Fetch error:", err);
				setError(err.message);
				setData([]);
				setPagination({
					total: 0,
					totalPages: 0,
					hasNextPage: false,
					hasPrevPage: false,
				});
			} finally {
				setLoading(false);
			}
		};
		fetchData();
	}, [year, category, currentPage]);

	const handlePageChange = (page) => {
		if (page > 0 && page <= pagination.totalPages) {
			setCurrentPage(page);
			window.scrollTo({ top: 0, behavior: "smooth" });
		}
	};

	// Debug: Add this to see what's happening
	console.log("Current state:", {
		year,
		category,
		backendCategory: getBackendCategory(category),
		dataLength: data.length,
		loading,
		error,
	});

	if (loading)
		return (
			<div className="flex flex-col justify-center items-center min-h-screen bg-gray-50">
				<Icon
					icon="svg-spinners:ring-resize"
					className="w-16 h-16 text-pink-600 animate-spin-slow"
				/>
				<div className="text-xl font-semibold text-gray-700 mt-4 font-poppins">
					Loading Monsini Collection...
				</div>
				<p className="text-sm text-gray-500 mt-1">
					Fetching the latest styles.
				</p>
			</div>
		);

	if (error)
		return <div className="text-center mt-20 text-red-500">Error: {error}</div>;

	return (
		<div className="">
			<Navbar />
			<h1
				className={`mt-[90px] text-5xl font-extrabold font-americana text-center mb-16 text-white py-20 tracking-tight
    ${
			category === "prom"
				? "bg-pink-300"
				: category === "bridal"
				? "bg-pink-500"
				: category === "evening"
				? "bg-[#072349]"
				: "bg-[#072349]"
		}
  `}>
				{category === "prom"
					? `Monsini Prom ${year}`
					: category === "bridal"
					? `Enchanted Bridal ${year}`
					: category === "evening"
					? `Enchanted Evening ${year}`
					: ""}{" "}
				Collection
			</h1>

			{data && data.length > 0 ? (
				<>
					<div className="py-5 px-6 sm:px-10 lg:px-20 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
						{data.map((item, index) => (
							<Link
								to={`/product/id/${item.style}`}
								state={{
									product: item,
								}}
								key={item._id || index}
								className="bg-white shadow-lg overflow-hidden group border-b-4 border-transparent hover:border-b-4 transition-all duration-300 transform hover:shadow-xl"
								style={{ borderBottomColor: PRIMARY_COLOR }}>
								<div className="relative overflow-hidden">
									{item.images && item.images[0] && (
										<img
											src={
												item.images[0].startsWith("http")
													? item.images[0]
													: `https://admin.monsinidress.com/${item.images[0]}`
											}
											alt={item.style}
											className="w-full lg:h-[450px] md:h-[300px] sm:h-[450px] h-[450px] object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
											onError={(e) => {
												console.error("Image failed to load:", item.images[0]);
												e.target.src = "/fallback-image.jpg"; // Add a fallback image
											}}
										/>
									)}
									<div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent flex items-end opacity-0 group-hover:opacity-100 transition-opacity duration-300">
										<div className="p-4 w-full text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out">
											<div className="flex justify-between items-center mb-2">
												<h2 className="font-bold text-xl drop-shadow-md">
													{item.style}
												</h2>
												<div className="flex justify-between items-center text-sm">
													<button
														className="px-4 py-1.5 rounded-full text-sm font-semibold transition-colors"
														style={{
															backgroundColor: PRIMARY_COLOR,
															color: "white",
														}}
														onMouseOver={(e) =>
															(e.currentTarget.style.backgroundColor =
																HOVER_COLOR)
														}
														onMouseOut={(e) =>
															(e.currentTarget.style.backgroundColor =
																PRIMARY_COLOR)
														}>
														View Dress
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</Link>
						))}
					</div>

					{/* Pagination Controls */}
					{pagination.totalPages > 1 && (
						<div className="flex justify-center items-center my-10 space-x-2 md:flex-row sm:flex-col flex-col gap-4">
							<button
								onClick={() => handlePageChange(currentPage - 1)}
								disabled={!pagination.hasPrevPage}
								className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-300 ${
									!pagination.hasPrevPage
										? "bg-gray-200 text-gray-500 cursor-not-allowed"
										: "text-white"
								}`}
								style={{
									backgroundColor: pagination.hasPrevPage
										? PRIMARY_COLOR
										: undefined,
								}}
								onMouseOver={(e) =>
									pagination.hasPrevPage &&
									(e.currentTarget.style.backgroundColor = HOVER_COLOR)
								}
								onMouseOut={(e) =>
									pagination.hasPrevPage &&
									(e.currentTarget.style.backgroundColor = PRIMARY_COLOR)
								}>
								Previous
							</button>

							<div className="flex gap-2">
								{[...Array(pagination.totalPages).keys()].map((page) => {
									const pageNum = page + 1;
									if (
										pageNum === 1 ||
										pageNum === pagination.totalPages ||
										(pageNum >= currentPage - 1 && pageNum <= currentPage + 1)
									) {
										return (
											<button
												key={pageNum}
												onClick={() => handlePageChange(pageNum)}
												className={`w-10 h-10 rounded-full font-semibold transition-colors duration-300 ${
													pageNum === currentPage
														? "bg-pink-300 text-white shadow-md"
														: "bg-gray-100 text-gray-700 hover:bg-gray-200"
												}`}
												style={
													pageNum === currentPage
														? { backgroundColor: PRIMARY_COLOR, color: "white" }
														: {}
												}>
												{pageNum}
											</button>
										);
									}
									if (pageNum === 2 && currentPage > 2) {
										return (
											<span key="start-ellipsis" className="text-gray-500">
												...
											</span>
										);
									}
									if (
										pageNum === pagination.totalPages - 1 &&
										currentPage < pagination.totalPages - 1
									) {
										return (
											<span key="end-ellipsis" className="text-gray-500">
												...
											</span>
										);
									}
									return null;
								})}
							</div>

							<button
								onClick={() => handlePageChange(currentPage + 1)}
								disabled={!pagination.hasNextPage}
								className={`px-4 py-2 rounded-full md:text-sm font-semibold transition-colors duration-300 ${
									!pagination.hasNextPage
										? "bg-gray-200 text-gray-500 cursor-not-allowed"
										: "text-white"
								}`}
								style={{
									backgroundColor: pagination.hasNextPage
										? PRIMARY_COLOR
										: undefined,
								}}
								onMouseOver={(e) =>
									pagination.hasNextPage &&
									(e.currentTarget.style.backgroundColor = HOVER_COLOR)
								}
								onMouseOut={(e) =>
									pagination.hasNextPage &&
									(e.currentTarget.style.backgroundColor = PRIMARY_COLOR)
								}>
								Next
							</button>
						</div>
					)}
				</>
			) : (
				<div className="text-center text-gray-600 mt-20 p-10 bg-gray-50 rounded-xl">
					<p className="text-xl font-semibold mb-8">
						No data available for {year} {category} collection.
					</p>
					<a
						href="/"
						className="inline-block px-8 py-3 rounded-full text-lg font-semibold transition-colors duration-300 shadow-lg"
						style={{ backgroundColor: PRIMARY_COLOR, color: "white" }}
						onMouseOver={(e) =>
							(e.currentTarget.style.backgroundColor = HOVER_COLOR)
						}
						onMouseOut={(e) =>
							(e.currentTarget.style.backgroundColor = PRIMARY_COLOR)
						}>
						Back to Collections
					</a>
				</div>
			)}
			<Footer />
		</div>
	);
}
